import { render, staticRenderFns } from "./DeleteCeremonyModal.vue?vue&type=template&id=a97ff866"
import script from "./DeleteCeremonyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteCeremonyModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports